module.exports = __webpack_public_path__ + "img/SymSimaOran.85d4e38e.png";